import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUnlockedUnconstrained = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 2.25C8.82436 2.25 6.25 4.82436 6.25 8L6.25 9.5C6.25 9.91421 6.58579 10.25 7 10.25C7.41421 10.25 7.75 9.91421 7.75 9.5V8C7.75 5.65279 9.65279 3.75 12 3.75C14.3472 3.75 16.25 5.65279 16.25 8V9.5C16.25 9.91421 16.5858 10.25 17 10.25C17.4142 10.25 17.75 9.91421 17.75 9.5V8C17.75 4.82436 15.1756 2.25 12 2.25Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.75 14.5C7.75 14.0858 7.41421 13.75 7 13.75C6.58579 13.75 6.25 14.0858 6.25 14.5V16C6.25 19.1756 8.82436 21.75 12 21.75C15.1756 21.75 17.75 19.1756 17.75 16V14.5C17.75 14.0858 17.4142 13.75 17 13.75C16.5858 13.75 16.25 14.0858 16.25 14.5V16C16.25 18.3472 14.3472 20.25 12 20.25C9.65279 20.25 7.75 18.3472 7.75 16V14.5Z",
		fill: "currentColor"
	})]
});
export { SvgIconUnlockedUnconstrained as ReactComponent };
